import { defineComponent, useCssVars, computed } from "vue";
import { getConfig } from "./component-library2.mjs";
import { addCdnHost } from "./component-library241.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "image-element",
  props: {
    src: { default: void 0 },
    aspectRatio: { default: void 0 },
    imageClass: { default: void 0 },
    imageStyle: { default: void 0 },
    alt: { default: "" },
    lazy: { type: Boolean },
    format: { default: "webp" },
    doNotConvert: { type: Boolean },
    sizes: { default: "" },
    preload: { type: Boolean }
  },
  emits: ["image-error"],
  setup(__props, { expose }) {
    var _a;
    const props = __props;
    useCssVars((_vm, _setup) => ({
      "1c027e72": _setup.aspectRatio
    }));
    const aspectRatio = computed(() => props.aspectRatio);
    const processSrcset = (srcset) => {
      if (!srcset)
        return void 0;
      const entries = srcset.split(", ");
      const processedEntries = entries.map((entry) => {
        const trimmedEntry = entry.trim();
        const [url, width] = trimmedEntry.split(" ");
        const newUrl = addCdnHost(url);
        return `${newUrl} ${width}`;
      });
      return processedEntries.join(", ");
    };
    const defaultImage = computed(() => {
      const { imageOptimizer } = getConfig() || {};
      if (props.doNotConvert || !imageOptimizer || !props.src || !props.sizes) {
        return {
          src: props.src ? addCdnHost(props.src) : "",
          type: `image/${props.format}`,
          sizes: void 0,
          srcset: void 0
        };
      }
      const { srcset, sizes, src } = imageOptimizer(props.src, {
        sizes: props.sizes,
        modifiers: {
          format: props.format
        }
      });
      return {
        src: addCdnHost(src),
        type: `image/${props.format}`,
        sizes,
        srcset: processSrcset(srcset)
      };
    });
    const mockUseHead = (callback) => {
    };
    const useHead = ((_a = getConfig()) == null ? void 0 : _a.useHead) || mockUseHead;
    useHead(() => {
      var _a2;
      if (!props.preload || !((_a2 = defaultImage.value) == null ? void 0 : _a2.src))
        return {};
      return {
        link: [
          {
            rel: "preload",
            as: "image",
            href: defaultImage.value.src || ""
          }
        ]
      };
    });
    expose({
      defaultImage
    });
    return { __sfc: true, props, aspectRatio, processSrcset, defaultImage, mockUseHead, useHead };
  }
});
export {
  _sfc_main as default
};
